import React from 'react';
import styled from 'styled-components';
import { FullPage } from '../components/FullPage';
import { useParams, useHistory } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/client';
import { Delete } from '@styled-icons/material/Delete';

import { useTranslation } from 'react-i18next';
import {Button} from '../components/Button';
import {
  ADMIN_GET_UNIT_QUERY,
  ADMIN_DELETE_UNIT_MUTATION,
  AdminUnitData,
  deleteUpdateCache
} from '../graphql/units';

const StyledDeletePage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const DeleteIcon = styled(Delete)`
  color: ${props => props.theme.colors.main};
  height: ${props => props.theme.spacing.default*2}px;
  width: ${props => props.theme.spacing.default*2}px;
`

export const DeleteUnitPage = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const { eventId, factionId, unitId: id } = useParams();
  const { loading: getUnitLoading, data: getUnitData } = useQuery<AdminUnitData>(ADMIN_GET_UNIT_QUERY, { variables: { eventId, factionId, id }});

  const [adminDeleteUnit, { loading: deleting }] = useMutation(ADMIN_DELETE_UNIT_MUTATION);

  const onDelete = () => {
    adminDeleteUnit({
      variables: { eventId, factionId, id },
      update: (client, result) => deleteUpdateCache(eventId, factionId, client, result)
    })
      .then(() => {
        history.push(`/events/${eventId}/factions/${factionId}/units`)
      })
  }

  return (
    <FullPage
      heading={deleting ? t('delete'): getUnitData?.adminGetUnit.name as string}
      loading={deleting || getUnitLoading}
      closeHandler={() => history.push(`/events/${eventId}/factions/${factionId}/units`)}
    >
      <StyledDeletePage>
        <h2>{t('delete')} {getUnitData?.adminGetUnit.name}?</h2>
        <Button clickHandler={onDelete} size={'lg'}><DeleteIcon /> {t('delete')}</Button>
      </StyledDeletePage>
    </FullPage>
  )
}
